/**
 * Display labels for variant attribute groups.
 *
 * The Figma names the two common groups in the plural ("Colours", "Materials")
 * while the CMS stores them singular. Every other attribute a product defines —
 * Finish, Frame, Trim — is shown under its own name, so the page and the
 * purchase drawer read the same way whatever a supplier configures.
 */

/** "Colour" → "Colours" etc., matching the Figma's labels. */
export const groupLabelFor = (attributeName: string): string =>
    attributeName === 'Colour'
        ? 'Colours'
        : attributeName === 'Material'
          ? 'Materials'
          : attributeName;

/**
 * Labeller scoped to the attributes one product actually carries. It declines to
 * pluralise into a label another attribute already owns — some products define
 * both a "Material" and a "Materials" group, and collapsing them would render
 * two identically titled columns.
 */
export const makeGroupLabeller = (
    attributeNames: string[],
): ((name: string) => string) => {
    return (name: string) => {
        const mapped = groupLabelFor(name);
        return mapped !== name && attributeNames.includes(mapped)
            ? name
            : mapped;
    };
};
